import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { selectSelectedCompanyDocument, useAppSelector } from '@ibk/shared-config';
import { AppDomain } from '@ibk/shared-types';
import { useSearchAccountantEmissorContractsQuery, useSearchClientEmissorContractsQuery, } from '../services/contractStatusApi';
import { EmissorContractStatus } from '../types/contractStatus';
export const CONTRACT_STATUS_POLLING_INTERVAL_MS = 5000;
export const BENEFITS_HOME_PATH = '/beneficios';
const EXISTING_CONTRACT_STATUSES = [
    EmissorContractStatus.REQUESTED,
    EmissorContractStatus.CREATED,
    EmissorContractStatus.ACTIVATED,
];
export function getContractStatusPollingInterval(status) {
    if (status === EmissorContractStatus.REQUESTED || status === EmissorContractStatus.CREATED) {
        return CONTRACT_STATUS_POLLING_INTERVAL_MS;
    }
    return 0;
}
export function useContractStatusTracking({ appDomain, skip = false, redirectOnActive = true, }) {
    const navigate = useNavigate();
    const isAccountant = appDomain === AppDomain.ESCRITORIO;
    const document = useAppSelector(selectSelectedCompanyDocument);
    const hasDocument = Boolean(document);
    const [pollingInterval, setPollingInterval] = useState(0);
    const queryArg = {
        document: document ?? undefined,
        status: EXISTING_CONTRACT_STATUSES,
        limit: 1,
        sort: '-createdAt',
    };
    const accountantQuery = useSearchAccountantEmissorContractsQuery(queryArg, {
        pollingInterval,
        skipPollingIfUnfocused: true,
        refetchOnMountOrArgChange: true,
        skip: skip || !isAccountant || !hasDocument,
    });
    const clientQuery = useSearchClientEmissorContractsQuery(queryArg, {
        pollingInterval,
        skipPollingIfUnfocused: true,
        refetchOnMountOrArgChange: true,
        skip: skip || isAccountant || !hasDocument,
    });
    const activeQuery = isAccountant ? accountantQuery : clientQuery;
    const { data, isLoading, isError } = activeQuery;
    const contract = data?.[0] ?? null;
    const status = contract?.status ?? null;
    const hasContract = contract !== null;
    const isActivated = status === EmissorContractStatus.ACTIVATED;
    useEffect(() => {
        setPollingInterval(getContractStatusPollingInterval(status));
    }, [status]);
    useEffect(() => {
        if (redirectOnActive && isActivated) {
            navigate(BENEFITS_HOME_PATH, { replace: true });
        }
    }, [isActivated, navigate, redirectOnActive]);
    return {
        contract,
        status,
        hasContract,
        isLoading,
        isError,
    };
}
